<template>
  <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
    <h1>{{ "" }}</h1>
  </transition>
  <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
    <div data-index="1">
      <h2>I'd Love to hear from you.</h2>
      <p>{{ bio }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    bio: String,
    beforeEnterH1: Function,
    enterH1: Function,
    beforeEnterBox: Function,
    enterBox: Function,
  },
};
</script>
